import React from "react";
import { FormattedTimeUnit } from "@I18n/Components/FormattedTimeUnit/FormattedTimeUnit";
import { IServiceOffer } from "@modules/ServiceAssignment/services/serviceOffers";
import { IServiceFeesFeature } from "@modules/ServiceFees/services/serviceFeesFeature";
import { ISubscriptionPlan } from "@modules/Subscriptions/types";

export interface IPricingBreakdown {
  isVisitOffer: boolean;
  unitNode: React.ReactNode;
  serviceFeePercentage: number;
  serviceFeeAmountCents: number;
  totalExpensesCents: number;
  expensesFeesCents: number;
  standardTotalCents: number;
  subscriptionTotalCents: number;
  quarterlyPlan: ISubscriptionPlan | undefined;
}

export const computePricingBreakdown = (
  serviceOffer: IServiceOffer,
  serviceFeesFeature: IServiceFeesFeature | undefined,
  subscriptionPlans: ISubscriptionPlan[] | undefined
): IPricingBreakdown => {
  const isVisitOffer = serviceOffer.rateType === "estimate";
  const { billingUnit } = serviceOffer;
  const unitNode: React.ReactNode =
    billingUnit && billingUnit !== "flat" ? (
      <> / <FormattedTimeUnit unit={billingUnit} format="long" /></>
    ) : null;

  const serviceFeePercentage =
    serviceFeesFeature?.details?.chargedToClient?.clientServiceFee?.percentage ?? 0;
  const serviceFeeAmountCents = Math.round(
    serviceOffer.rateCents * (serviceFeePercentage / 100)
  );
  const totalExpensesCents =
    serviceOffer.expenses?.reduce((sum, e) => sum + e.amountCents, 0) ?? 0;
  const expensesFeesCents = serviceOffer.expensesFeesCents ?? 0;
  const standardTotalCents =
    serviceOffer.rateCents + serviceFeeAmountCents + totalExpensesCents + expensesFeesCents;
  const subscriptionTotalCents = serviceOffer.rateCents + totalExpensesCents;
  const quarterlyPlan = subscriptionPlans?.find(
    (plan) => plan.name === "quarterly_subscription"
  );

  return {
    isVisitOffer,
    unitNode,
    serviceFeePercentage,
    serviceFeeAmountCents,
    totalExpensesCents,
    expensesFeesCents,
    standardTotalCents,
    subscriptionTotalCents,
    quarterlyPlan,
  };
};
